import globalStore from '@/services/global.state';
import {BasicObject, SafeAny} from '@/types';

/** 请求层初始化所需的轻量运行时能力，禁止从 utils 聚合入口导入。 */
export const inApp =
  typeof navigator !== 'undefined' &&
  navigator.userAgent.indexOf('Pandora') > -1;

export function getAppVersion() {
  if (typeof navigator === 'undefined') {
    return '999';
  }
  const result =
    navigator.userAgent.match(/versionCode\/(\d+)/) ||
    navigator.userAgent.match(/AppVersion\/(\d+)/);
  return result?.[1] || '999';
}

export const parseCookie = (cookieString?: string) => {
  if (!globalStore.isWeb) {
    return {};
  }
  const source = cookieString || document.cookie;
  const cookieObject: BasicObject = {};
  source.split(';').forEach(cookie => {
    const [key, value] = cookie.trim().split('=');
    cookieObject[key] = decodeURIComponent(value);
  });
  return cookieObject;
};

export const errorLog = (...args: SafeAny[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(args);
  }
};

export function generateRandomStr(count: number) {
  const chars =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let index = 0; index < count; index++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}
